var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-14",attrs:{"id":"app"}},[(_vm.showLoginOverlay)?_c('LoginOverlay',{staticClass:"fixed z-20",on:{"closePrompt":_vm.closeLoginPrompt}}):_vm._e(),_c('NavBar'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"max-h-[calc(100vh-3.5rem)] min-h-[calc(100vh-3.5rem)] overflow-y-auto"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }